import React from "react";

import { Box, Typography, darken } from "@mui/material";
import { getHours } from "date-fns";
import { makeStyles } from "tss-react/mui";

import GoodMorningIcon from "@/components/Icons/GoodMorningIcon";
import { colors } from "@/theme/overrides/colors";
import GoodAfternoonIcon from "@components/Icons/GoodAfternoonIcon";
import GoodEveningIcon from "@components/Icons/GoodEveningIcon";



const useStyles = makeStyles()((theme) => ({
  banner: {
    margin: theme.spacing(5, 0, 9.5, 5),
  },
  coachName: {
    alignSelf: "center",
    fontSize: theme.typography.pxToRem(28),
    fontWeight: 500,
    marginRight: 8,
  },
  mainContentWrapper: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "100%",
  },
  middleContentWrapper: {
    display: "flex",
    flexDirection: "column",
    marginRight: 12,
  },
  greetingIcon: {
    height: 65,
    width: 65,
    alignSelf: "center",
    marginRight: 32,
    fontSize: 300,
  },
  greetingText: {
    alignSelf: "center",
    fontSize: theme.typography.pxToRem(28),
    fontWeight: 300,
    marginRight: 8,
  },
  manageSubscriptionButton: {
    flexShrink: 0,
    marginLeft: "auto",
  },
  suspendedDialog: {
    minWidth: 1255,
    backgroundColor: "#FF6262",
    color: colors.white,
  },
  suspendedDialogContent: {
    padding: theme.spacing(0, 8, 8),
  },
  suspendedDialogHead: {
    display: "flex",
    justifyContent: "flex-end",
  },
  suspendedDialogTitle: {
    margin: theme.spacing(5, 0, 7),
    fontSize: "1.75rem",
  },
  suspendedDialogDescription: {
    marginBottom: theme.spacing(7),
    fontWeight: 600,
    fontSize: 12,
    lineHeight: 1.25,
  },
  suspendedDialogButton: {
    marginBottom: theme.spacing(8),
    backgroundColor: "#0B1B26",
    color: colors.white,
    "&:hover": {
      backgroundColor: darken("#0B1B26", 0.2),
    },
  },
}));

type Props = {
  fullName: string;
};

const GreetingsMessage: React.FC<Props> = ({ fullName }) => {
  const { classes } = useStyles();

  const hoursOfTheDay = getHours(new Date());
  const greetingMessage =
    hoursOfTheDay < 12
      ? "Good morning,"
      : hoursOfTheDay < 18
      ? "Good afternoon,"
      : "Good evening,";

  const greetingIcon =
    hoursOfTheDay < 12 ? (
      <GoodMorningIcon className={classes.greetingIcon} />
    ) : hoursOfTheDay < 18 ? (
      <GoodAfternoonIcon className={classes.greetingIcon} />
    ) : (
      <GoodEveningIcon className={classes.greetingIcon} />
    );

  return (
    <Box
      display="flex"
      flexDirection="row"
      marginTop={2}
      marginLeft={4}
      alignItems="center"
    >
      {greetingIcon}
      <Typography
        variant="h4"
        fontWeight={300}
        className={classes.greetingText}
        marginRight={2}
      >
        {greetingMessage}
      </Typography>
      <Typography variant="h4" className={classes.coachName}>
        {fullName}
      </Typography>
    </Box>
  );
};

export default GreetingsMessage;
